module.exports = __webpack_public_path__ + "static/media/fun12.29154de7.png";